import { randomBetween } from '../utils/formatters'

/**
 * Generate candlestick data for different timeframes
 */
export const generateCandleData = (basePrice = 100, count = 100, timeframe = '1D') => {
  const data = []
  const now = Date.now()
  let currentPrice = basePrice
  
  // Timeframe intervals in milliseconds
  const intervals = {
    '1D': 24 * 60 * 60 * 1000,
    '1W': 7 * 24 * 60 * 60 * 1000,
    '1M': 30 * 24 * 60 * 60 * 1000,
    '1Y': 365 * 24 * 60 * 60 * 1000,
  }
  
  const interval = intervals[timeframe] || intervals['1D']
  const volatility = timeframe === '1D' ? 0.02 : timeframe === '1W' ? 0.05 : 0.08
  
  for (let i = count; i >= 0; i--) {
    const timestamp = now - i * interval
    const date = new Date(timestamp)
    
    // Random walk for price
    const trend = randomBetween(-volatility, volatility)
    currentPrice = currentPrice * (1 + trend)
    
    // OHLC values
    const open = currentPrice * randomBetween(0.99, 1.01)
    const close = currentPrice * randomBetween(0.99, 1.01)
    const high = Math.max(open, close) * randomBetween(1.0, 1.03)
    const low = Math.min(open, close) * randomBetween(0.97, 1.0)
    const volume = Math.floor(randomBetween(500000, 5000000))
    
    data.push({
      time: date.toISOString().split('T')[0],
      timestamp,
      open: parseFloat(open.toFixed(2)),
      high: parseFloat(high.toFixed(2)),
      low: parseFloat(low.toFixed(2)),
      close: parseFloat(close.toFixed(2)),
      volume,
    })
  }
  
  return data
}

/**
 * Pre-generated candle data for different symbols and timeframes
 */
export const CANDLE_DATA = {
  BTCUSD: {
    '1D': generateCandleData(43250, 30, '1D'),
    '1W': generateCandleData(43250, 52, '1W'),
    '1M': generateCandleData(43250, 12, '1M'),
    '1Y': generateCandleData(43250, 5, '1Y'),
  },
  ETHUSD: {
    '1D': generateCandleData(2285, 30, '1D'),
    '1W': generateCandleData(2285, 52, '1W'),
    '1M': generateCandleData(2285, 12, '1M'),
    '1Y': generateCandleData(2285, 5, '1Y'),
  },
  AAPL: {
    '1D': generateCandleData(189.95, 30, '1D'),
    '1W': generateCandleData(189.95, 52, '1W'),
    '1M': generateCandleData(189.95, 12, '1M'),
    '1Y': generateCandleData(189.95, 5, '1Y'),
  },
  SPY: {
    '1D': generateCandleData(456.78, 30, '1D'),
    '1W': generateCandleData(456.78, 52, '1W'),
    '1M': generateCandleData(456.78, 12, '1M'),
    '1Y': generateCandleData(456.78, 5, '1Y'),
  },
  XAUUSD: {
    '1D': generateCandleData(2034.5, 30, '1D'),
    '1W': generateCandleData(2034.5, 52, '1W'),
    '1M': generateCandleData(2034.5, 12, '1M'),
    '1Y': generateCandleData(2034.5, 5, '1Y'),
  },
  EURUSD: {
    '1D': generateCandleData(1.0875, 30, '1D'),
    '1W': generateCandleData(1.0875, 52, '1W'),
    '1M': generateCandleData(1.0875, 12, '1M'),
    '1Y': generateCandleData(1.0875, 5, '1Y'),
  },
}

/**
 * Get candle data for a symbol and timeframe
 */
export const getCandleData = (symbol, timeframe = '1D') => {
  return CANDLE_DATA[symbol]?.[timeframe] || CANDLE_DATA.BTCUSD['1D']
}
